import { useUpdateEffect } from 'ahooks';
import React from 'react';
import { getSpecificParent } from '@apia/util';
import { SimpleButton } from '../components';
import { DefaultTabsLabelRenderer } from './renderers/DefaultTabsLabelRenderer';
import { observer } from 'mobx-react-lite';
import { Tab } from './tabsController';

const Item = observer(({ tab }: { tab: Tab }) => {
  const Renderer = React.useMemo(
    () => tab.state.labelRenderer ?? DefaultTabsLabelRenderer,
    [tab.state.labelRenderer],
  );

  const ref = React.useRef<HTMLButtonElement>({} as HTMLButtonElement);
  useUpdateEffect(() => {
    if (tab.state.isFocused) {
      ref.current?.focus({
        preventScroll: true,
      });
    }
  }, [tab.state.isFocused]);
  React.useEffect(() => {
    if (tab.state.isOpen) {
      const scrollParent = getSpecificParent(ref.current, (current) =>
        current.classList.contains('tabs__list'),
      ) as HTMLElement;

      scrollParent?.scroll({
        left: ref.current.offsetLeft - 100,
      });
    }
  }, [tab.state.isOpen]);

  const buttonProps = {
    className: `tabs__item__wrapper ${tab.state.isOpen ? 'open' : ''} ${
      tab.state.isDisabled ? 'disabled' : ''
    }`,
    title: tab.state.title ?? tab.state.label,
    onMouseDown: React.useCallback(
      (ev: React.MouseEvent) => {
        if (ev.button === 1) {
          tab.close();
        } else if (ev.button === 0) tab.open();
      },
      [tab],
    ),
    'aria-controls': `tabpanel-${tab.controller.id}-${tab.state.id}`,
    'aria-selected': tab.state.isOpen ?? false,
    id: `tab-${tab.controller.id}-${tab.id}`,
    tabIndex: tab.state.isOpen ? 0 : -1,
    role: 'tab',
    variant: 'inherit',
  };

  return (
    <SimpleButton data-id={tab.id} ref={ref} {...buttonProps}>
      <Renderer tab={tab} />
    </SimpleButton>
  );
});

export default Item;
